const markInterestDone = state => state.markInterestDone;
const noInterestMarksLeft = state => state.noInterestMarksLeft;
const lastMarked = state => state.lastMarked;
const isSuperLiked = state => propositionId =>
  state.superLikedIds.includes(String(propositionId));

export default {
  markInterestDone,
  noInterestMarksLeft,
  lastMarked,
  isSuperLiked
};
